import { TextDrawer, validTypes } from "./TextDrawer";
export async function loadTextShape(engine, refresh = true) {
    await engine.addShape(validTypes, new TextDrawer(), refresh);
}
